import React from 'react';
import ImgIconComp from './../imgcomp';
import  { withTranslation } from 'react-i18next';
/*Share Board to someoOne */
class SharedPopupComp extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            item: this.props.item || {}, // this contains board obj or rbr obj
            members: this.props.sharedMembers || [],
            removedMembers: [],
            sharedType: this.props.sharedType            
        };
        this.registerAutocomplete = this.registerAutocomplete.bind(this);
        this.addTeamMembers = this.addTeamMembers.bind(this);
        this.addUsers = this.addUsers.bind(this);
        this.addSharedMembers = this.addSharedMembers.bind(this);
        this.closeShareBoard = this.closeShareBoard.bind(this);
        this.clickSharedBoard = this.clickSharedBoard.bind(this);
        this.removeSharedUser = this.removeSharedUser.bind(this);
        this.userPermission = this.userPermission.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
    }

    componentDidMount(){
        this.registerAutocomplete();
    }

    registerAutocomplete(){
        let orgUsers = this.props.orgUsers || [];
        let _this = this;
        $(_this.refs.add_shared_users).autocomplete({
            //source: orgUsers,GetRelatedMembers
            minLength: 3,
            source: function (request, response) {
                let params = {} ;
                var term = request.term;
                params.term = term;
                params.teamRoles = true;
                params.team = true;
                params.fromOrg = true;
                $.ajax({
                    url: wbConfig.baseUrl + '/team/searcUserListsForAllMyTeams',
                    type: 'get',
                    dataType: "json",
                    data: params,
                })
                .done(function (value) {
                    var reports = [];
                    $.map(value, function (item, key) {
                        reports.push({
                            label: item['label'],
                            value: item['value'],
                            teamId:item['teamId'],
                            teamName:item['teamName'],
                            allTeamName:item['allTeamName'],
                            userPic: item['userPic'],
                            userId: item['userId'],
                            firstName: item['firstName'],
                            lastName: item['lastName'],
                            role: item['role'],
                            type: item['type']
                        });
                    }),
                    response(reports);
                });

            },
            select: function(event, ui){
                if (ui.item.teamId == "0") {
                    _this.addTeamMembers(ui.item.value);
                }
                else {
                    _this.addUsers(ui.item);
                }
                $(this).val(""); 
                return false;
            },
            focus: function(event, ui){
                $(this).val(ui.item.label); return false;
            }
        })
        .data("ui-autocomplete")._renderItem = function (ul, item) {
            var classVal = '';
            if(item.teamId == 0) {
                classVal = 'teamListUl';
            }
            return $( '<li></li>' )
                .data( 'item.autocomplete', item )
                .append( '<a class=\"truncateText '+classVal+'\">' + item.label + '</a>' )
                .appendTo( ul );
        };
    }

    addTeamMembers(teamId){
        if(teamId){
            let _this = this;
            $.get(wbConfig.baseUrl + '/board/getTeamMembers', {id: teamId}, function(resp){
                if(resp.teamMembers){
                    let _members = resp.teamMembers || [];
                    if(_members.length){
                        _this.addSharedMembers(_members, true);
                    }
                }
            });
        }
    }

    addUsers(user){
        this.addSharedMembers([user]);
    }

    addSharedMembers(members, teamUser = false){
        if(Array.isArray(members) && members.length){
            let users = [];
            members.map(m => {
                let u = {};
                if(teamUser){
                    u.firstname = m.name;
                    u.lastname  = m.lastName;
                    u.fullName  = `${m.name} ${m.lastName}`;
                    u.picture   = m.pic;
                    u.user_id   = m.id;
                    u.access_type = 1;
                    u.isNew      = 1;
                }
                else {
                    u.firstname = m.firstName;
                    u.lastname  = m.lastName;
                    u.fullName  = `${m.firstName} ${m.lastName}`;
                    u.picture   = m.userPic;
                    u.user_id   = m.userId;
                    u.access_type = 1;
                    u.isNew      = 1;
                }
                users = users.concat(u);
            });
            if(users.length){
                let members = this.state.members;
                users = users.filter(u => !members.find(u1 => u1.user_id == u.user_id));
                if(users.length){
                    members = members.concat(users);
                    this.setState({members: members});
                }
            }
        }
    }

    closeShareBoard(){
        $(shareBoardDatapopUp).dialog('close');
        if(typeof this.props.closeCallback === 'function'){
            this.props.closeCallback.apply(null, [this]);
        }
    }

    clickSharedBoard(e){
        let params = {}, _this = this;
        let {actions} = this.props;
        if(typeof this.props.saveCallback === 'function'){
            params.id = _this.state.item.id,
            params.members = _this.state.members;
            params.removed_users = _this.state.removedMembers.map(u => u.user_id);
            params.custom_message = _this.refs.custom_message.value;
            params.board_type = $('#board_org').is(":checked") ? _this.props.type_org : _this.props.type_shared; 
            _this.props.saveCallback.apply(null, [params, _this]);
        }
    }

    removeSharedUser(e, user){
       let members = this.state.members.filter(m => m.user_id != user.user_id);
        this.setState({
            members: members,
            removedMembers: this.state.removedMembers.concat(user)
        });
    }

    userPermission(e, user, access_type){
        let members = this.state.members.map(m => {
            if(m.user_id == user.user_id){
                m.access_type = access_type;
            }
            return m;
        });
        this.setState({
            members: members
        });
    }

    toggleCheckBox(e){
        let isChecked = e.target.checked ? this.props.type_org : this.props.type_shared;
        this.setState({sharedType: isChecked});
    }

    render(){
        const { t } = this.props;
        //let checkedBoardType = 1;
        let checkedSharedType = (this.state.sharedType == this.props.type_org) ? 1 : 0;
        let placeholerText = 'enter message here';
        let placeholderText = 'Search by team or person';
          return (
            <div className="wbmodal wbmodal-share">
                <div className="wbmodal-header">
                    <div className="wbmodal-htitle left shareBoardtitle">
                        <b>{this.props.title}</b>
                    </div>
                    <div className="wbmodal-hcancel right clickable" onClick={() => this.closeShareBoard()} style={{paddingTop:'5px',paddingRight:"12px"}}>
                        <ImgIconComp id="close" width="12" height="12" />
                    </div>
                    <div className="clear"></div>
                </div>
                <div className="wbmodal-content" style={{padding:'10px 30px'}}>
                    <div className="shareBoardtitle">
                        <span>{t("Custom message")}: </span>
                    </div>
                     <div className="addshare-text-wrapper">
                         <textarea name="custom_message" id="custom_message" ref="custom_message" placeholder={placeholerText} />
                    </div>
                    <div className="shareOrg">
                    <span className = "checkBoxStyle">
                        <input type="checkbox" name="board_org" id="board_org" onChange={e => this.toggleCheckBox(e)} checked={checkedSharedType} value={this.state.sharedType} />
                        <label htmlFor="board_org" className="checkboxLabel" style={{paddingRight: 0}}></label>
                    </span>
                    <span style={{padding: "0px 5px"}}><ImgIconComp id="rbr_org_icon" width="12" height="12" /></span>
                    <span>{t("Share with organization")}</span>
                    </div>
                    <div className="addshare-text-search">
                        <input type="text" name="s" id="add_shared_users" ref="add_shared_users" placeholder={placeholderText}/>
                    </div>
                    <div className="sharedMembers">
                        {
                            this.state.members.map(m => (
                                <div className="rbr-sharedmember">
                                    <div className ="sharedImage">
                                        <img src={m.picture} width="25" height="25" style={{borderRadius: '50%'}} />
                                    </div>
                                    <div className ="sharedName">
                                        {m.fullName}
                                    </div>
                                    <div className="gbl-butn-wraper sharedView" style={{width: '75px'}}>
                                        <div className={"rbr_button_option clickable " + (m.access_type == "1" ? " active " : "")} onClick={ e => this.userPermission(e, m, '1')}>{t("View")}</div>
                                    </div>
                                    <div className="gbl-butn-wraper sharedEdit" style={{width: '75px'}}>
                                        <div className={"rbr_button_option clickable " + (m.access_type == "2" ? " active " : "")} onClick={ e => this.userPermission(e, m, '2')}>{t("Edit")}</div>
                                    </div>
                                    <div className ="sharedDelete clickable" onClick={e => this.removeSharedUser(e, m)}>
                                        <ImgIconComp id="close"  width="10" height="10"  />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="gbl-butn-wraper" style={{float: 'right', width: '85px',paddingTop : '10px', marginTop: '30px', marginBottom: '20px'}}>
                        <div className="gbl-btn" onClick={ (e) => this.clickSharedBoard(e)}>{t("Share")}</div>
                    </div>
                </div>
            </div>
        );
    }
}

SharedPopupComp.defaultProps = {
    title: 'Share your Board',
    saveCallback: null,
    closeCallback: null,
    type_org: 2,
    type_shared: 1
};

export default withTranslation()(SharedPopupComp);